module.exports = __webpack_public_path__ + "media/img/raport-szkoda-bcg-a3249342.png";